export default {
  bookExperiencePanel: 'Panel rezervace zážitku',
  calendarIcon: 'Ikona kalendáře',
  coverImageForResource: 'Obrázek obálky pro {{title}} zážitky',
  filterBy: 'Filtrovat podle {{filter}}',
  filterByDateRange: 'Filtrovat podle časového rozsahu',
  gallery: 'Galerie',
  goBack: 'Zpět na předchozí stránku',
  hostUserIcon: 'Ikona hostujícího uživatele',
  imageOf: 'Obrázek {{title}}',
  interactiveMapAltText: 'Interaktivní mapa s výběrem {{title}}',
  mediaSlides: 'Mediální snímky',
  muteVideo: 'Ztlumit video',
  nextPhoto: 'Další fotografie',
  noVideoPlayback: 'Není dostupná přehrávací kapacita videa',
  pauseVideo: 'Pozastavit video',
  photoOf: 'Fotografie {{name}}',
  playVideo: 'Přehrát video',
  previousPhoto: 'Předchozí fotografie',
  moreFiltersAndExperiences: 'Více filtrů a zážitků',
  reserveSelectedSlot: 'Rezervovat vybraný slot',
  reviewRating: 'Hodnocení recenze {{rating}} z 5',
  overallReviewRating: 'Celkové hodnocení recenzí {{rating}} z 5',
  selectCountryCodeForPhoneNumber: 'Vyberte kód země pro telefonní číslo',
  selectDate: 'Vyberte datum',
  selectParticipants: 'Vyberte účastníky',
  selectSessionTime: 'Vyberte čas sezení',
  unmuteVideo: 'Zrušit ztlumení videa',
  viewShoppingCart: 'Zobrazit nákupní košík',
  itemsInCart: '{{count}} položek v nákupním košíku',
  zoomIn: 'Přiblížit',
  zoomOut: 'Oddálit',
  selectData: `Vyberte {{data}}`,
  reserveName: 'Rezervovat {{name}}',
  deleteReservation: 'Smazat {{experienceTitle}} rezervaci',
  editParticipantsFor: 'Upravit účastníky pro {{experienceTitle}}',
  enterPromoCode: 'Zadejte promo kód',
  applyPromoCode: 'Použít promo kód',
  increaseAddOnAmount: 'Zvýšit vybrané {{addOn}}',
  decreaseAddOnAmount: 'Snížit vybrané {{addOn}}',
  addOnModal: '{{addOn}} modální',
  moreInformationAboutAddOn: 'Další informace o {{addOn}}',
  decreasePriceTierTickets: 'Snížit {{priceTier}} vstupenky',
  increasePriceTierTickets: 'Zvýšit {{priceTier}} vstupenky',
  downloadFilename: 'Stáhnout {{filename}}',
  viewFullDetailsDescription: 'Zobrazit podrobný popis',
  viewFullDescription: 'Zobrazit úplný popis',
  closeModal: 'Zavřít modální okno',
  hyattBanner: 'Exkluzivní banner pro členy World of Hyatt',
  hyattBannerDesc:
    'Propagační banner upozorňující na exkluzivní výhody a nabídky dostupné členům věrnostního programu World of Hyatt',
  previousSlide: 'Předchozí snímek',
  nextSlide: 'Další snímek',
  paginationBulletMessage: 'Přejít na snímek',
  exitFullscreen: 'Ukončit celoobrazovkový režim',
  enterFullscreen: 'Zobrazit celoobrazovkově',
  videoSlide: 'Video snímek',
  imageSlide: 'Obrázek snímek',
  of: 'z',
  noDescription: 'Bez popisu',
  mediaGallery: 'Karusel - Mediální galerie',
  dateSelector: 'Výběr data',
  nextWeek: 'Další týden',
  previousWeek: 'Předchozí týden',
  scheduleAgenda: 'Agenda harmonogramu',
  scheduleNav: 'Navigace harmonogramu',
  scheduleViewSelector: 'Volba zobrazení harmonogramu',
  selectedDateAriaLabel: '{{date}}, vybráno',
  tapToBookExperience: 'Rezervovat {{title}}',
  bookExperienceAriaLabel: 'Rezervovat {{title}}',
  joinWaitlistAriaLabel: 'Připojit se k pořadníku pro {{title}}',
};
